/* eslint-disable */
import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import PropTypes from "prop-types";

const ITEM_HEIGHT = 48;

export default function MultiSearchBar({ searchOptions, setSearchOptions, marginTop = 5.5 }) {
  const [tempMenuOptions, setTempMenuOptions] = React.useState([...searchOptions]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSearchOptions(tempMenuOptions);
  };

  const handleMenuItemClick = (event) => {
    event.stopPropagation(); // Prevent closing the menu
  };

  const handleCheckboxChange = (event) => {
    const tempOptions = [...tempMenuOptions];
    const index = tempOptions.findIndex((option) => option.id === event.target.id);
    if (index === -1) return;
    tempOptions[index].checked = event.target.checked;
    setTempMenuOptions(tempOptions);
  };

  React.useEffect(() => {
    setTempMenuOptions([...searchOptions]);
  }, [searchOptions]);

  return (
    <div>
      <Button
        aria-label="filter visibility"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        startIcon={<TuneOutlinedIcon fontSize="small" sx={{ color: "#475467" }} />}
        sx={{
          mt: marginTop,
          mr: 1,
          height: 40,
          px: 2,
          backgroundColor: "#FFFFFF",
          color: "#000000",
          boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
          borderRadius: 0,
          border: "none",
          fontSize: 14,
          fontWeight: 400,
          textTransform: "none",
          "&:hover": {
            backgroundColor: "#FFFFFF",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
            border: "none",
          },
        }}
      >
        Filters
      </Button>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "25ch",
          },
        }}
      >
        {tempMenuOptions.map((option) => (
          <FormGroup key={option.id}>
            <MenuItem onClick={handleMenuItemClick}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={option.checked}
                    id={option.id}
                    onChange={handleCheckboxChange}
                  />
                }
                label={option.title || option.inputLabel}
                id={option.id}
              />
            </MenuItem>
          </FormGroup>
        ))}
      </Menu>
    </div>
  );
}

MultiSearchBar.propTypes = {
  searchOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  setSearchOptions: PropTypes.func.isRequired,
  marginTop: PropTypes.number,
};
